import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Indonesian NIK generator following Single Responsibility Principle
 */
export class IdGenerator extends BaseGenerator {
  generate(options = {}) {
    const { birthDate = null, gender = null } = options;

    // Province code (2 digits) - common Indonesian province codes
    const provinceCodes = ['11', '12', '13', '14', '15', '16', '17', '18', '19', '21'];
    const provinceCode = provinceCodes[this.randomInt(0, provinceCodes.length - 1)];

    // Regency code (2 digits)
    const regencyCode = this.padZero(this.randomInt(1, 99), 2);

    // District code (2 digits)
    const districtCode = this.padZero(this.randomInt(1, 99), 2);

    // Birth date (6 digits: DDMMYY)
    let ddmmyy;
    if (birthDate) {
      const date = new Date(birthDate);
      let day = date.getDate();
      
      // For females, add 40 to the day
      if (gender === 'female') {
        day += 40;
      }
      
      const month = this.padZero(date.getMonth() + 1, 2);
      const year = date.getFullYear().toString().slice(-2);
      ddmmyy = this.padZero(day, 2) + month + year;
    } else {
      let day = this.randomInt(1, 31);
      
      // Randomly decide gender if not specified
      const isFemaleBirth = gender === 'female' || (gender === null && this.randomInt(0, 1));
      if (isFemaleBirth) {
        day += 40;
      }
      
      const month = this.padZero(this.randomInt(1, 12), 2);
      const year = this.padZero(this.randomInt(0, 99), 2);
      ddmmyy = this.padZero(day, 2) + month + year;
    }

    // Serial number (4 digits)
    const serialNumber = this.randomDigits(4);

    return provinceCode + regencyCode + districtCode + ddmmyy + serialNumber;
  }
}